/** @jsx jsx */
import { jsx } from '@theme-ui/core';

import { useContext } from 'react';
import { IconUiClose, ButtonGhost } from '@uberall/zenit';

import styles from './stepper.module.css';
import Step from './step';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';

type StepperProps = {
    label: string;
    stepAmount?: number;
    onClose?: () => void;
};

const Stepper = ({ label, stepAmount = 3, onClose }: StepperProps) => {
    const { step: currentStep, setStep } = useContext(RequestAccessFormContext);

    const handleClose = () => {
        setStep(0);
        onClose?.();
    };

    return (
        <header className={styles.containerOutOfFlow} data-testid="stepper">
            <div className={styles.containerWidth}>
                <div className={styles.container}>
                    <ul className={styles.list}>
                        {[...Array(stepAmount).keys()].map((step) => (
                            <Step
                                key={step + 1}
                                step={step + 1}
                                label={label}
                                currentStep={currentStep}
                            />
                        ))}
                    </ul>
                    <ButtonGhost
                        onClick={handleClose}
                        icon={<IconUiClose />}
                        aria-label="Back"
                        // for the back icon we don't want any padding
                        sx={{ padding: 0 }}
                    />
                </div>
            </div>
        </header>
    );
};

export default Stepper;
